// El aviso tranquilo de "el servidor esta tardando, ya vuelve".
//
// Lissette, 2026-09-01: cuando sube una version nueva, a sus clientes se les
// queda la pantalla colgada un minuto y llaman diciendo "esto no abre".
//
// La app YA reintenta sola (`estadoDelServidor.js`), pero mientras reintenta
// no decia nada: la pantalla se quedaba muda y la persona pensaba que estaba
// rota. Este aviso es la mitad que faltaba — aparece en cuanto el servidor
// deja de contestar y se va solo en cuanto vuelve, sin que nadie toque nada.
//
// A proposito NO es rojo y NO se puede cerrar: no es un error, es una espera.
// Un aviso rojo con una X invita a cerrarlo y a llamar por telefono, que es
// justo lo que se esta evitando.
//
// ── POR QUE YA NO DICE "ESTAMOS ACTUALIZANDO" (2026-09-22, E-313) ──────────
//
// Nacio para la ventana del despliegue y por eso hablaba de una actualizacion.
// Pero quien lo enciende es `apiFetch`, y lo enciende por DOS motivos
// distintos: un 502/503 (que si suele ser un despliegue) y un intento que se
// paso de los 45 segundos (que es lentitud, y no tiene nada que ver). El
// segundo caso es el comun — es el que salio en E-188 con el boton de Hojas — y
// ahi el cartel afirmaba algo FALSO.
//
// Lo que costo: Lissette, 2026-09-22, "el sistema esta lentoo y no estoy
// haciendo ningun despliegue y sale el anuncio amarillo". El cartel la mando a
// buscar un despliegue que no existia (los del dia habian terminado dos horas
// antes) en vez de a lo que de verdad pasaba. Un aviso que nombra una causa
// que no es, dirige mal la busqueda — y quien lo lee no tiene forma de saberlo.
//
// El texto de hoy es verdad en los DOS casos: durante un despliegue el
// servidor tambien "tarda en responder". No nombra la causa porque esta
// pantalla no la sabe; dice lo unico que le consta y lo unico que le importa a
// quien lo lee: se arregla solo, no cierres nada.
import { useEffect, useState } from 'react';
import { estaReintentando, suscribirseAlServidor } from '../estadoDelServidor.js';

// ── AVISO DE INCIDENTE (E-377, 2026-10-21) ────────────────────────────────
//
// Cuando la caida es larga y de un proveedor (la base de Azure se quedo
// trabada en "Updating" al cambiarle el plan), el aviso de arriba no basta:
// solo sale con un 502/503 o un intento de mas de 45 s, y en esa caida el
// servidor contestaba 500 a los 20 s, asi que la gente veia errores sin
// explicacion. Con este texto puesto, el aviso sale SIEMPRE, con lo que de
// verdad pasa. `null` = sin incidente (lo normal). Se quita con otro
// despliegue en cuanto el servicio vuelve.
export const AVISO_DE_INCIDENTE = null;

export function AvisoDeServidor({ lang }) {
  const [reintentando, setVisible] = useState(estaReintentando);

  useEffect(() => {
    // Puede haber cambiado entre el primer pintado y la suscripcion.
    setVisible(estaReintentando());
    return suscribirseAlServidor(setVisible);
  }, []);

  const incidente = AVISO_DE_INCIDENTE;
  if (!reintentando && !incidente) return null;

  // El idioma del navegador y no el de la app: este aviso puede salir ANTES de
  // que la app haya cargado los ajustes de quien esta mirando.
  const es = lang
    ? lang === 'es'
    : !String(navigator?.language || 'es').toLowerCase().startsWith('en');

  return (
    <div
      role="status"
      aria-live="polite"
      /* Los colores van en linea y no por clase a proposito: este aviso puede
         tener que salir cuando lo que fallo es la propia hoja de estilos. Lo
         unico que se toma de dkt.css es el giro (`dkt-spin`), que ya existe y
         que sin el solo deja un punto quieto — se lee igual. La CSP permite
         estilos en el atributo (`style-src-attr 'unsafe-inline'`) pero NO un
         bloque <style> (`style-src-elem 'self'`); ver CLAUDE.md. */
      style={{
        position: 'fixed', top: 0, left: 0, right: 0, zIndex: 99999,
        display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 10,
        padding: '.5rem .9rem', boxSizing: 'border-box',
        background: 'rgba(255,183,0,.14)',
        borderBottom: '1px solid rgba(255,183,0,.45)',
        color: '#ffb700', fontSize: '.8rem', fontWeight: 700,
        fontFamily: 'system-ui, -apple-system, Segoe UI, Roboto, sans-serif',
        textAlign: 'center',
      }}
    >
      <span
        aria-hidden="true"
        className="dkt-spin"
        style={{
          width: 13, height: 13, borderRadius: '50%', flexShrink: 0,
          border: '2px solid rgba(255,183,0,.35)', borderTopColor: '#ffb700',
        }}
      />
      <span>
        {incidente
          ? (es ? incidente.es : incidente.en)
          : es
            ? 'El sistema está tardando en responder. Se reintenta solo — no cierres la página.'
            : 'The system is slow to respond. It retries on its own — do not close the page.'}
      </span>
    </div>
  );
}
